import React from 'react';
import {
  Select,
  MenuItem,
  makeStyles,
  withStyles,
  InputAdornment,
} from '@material-ui/core';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { TimePicker } from '../../constants';
import './index.scss';

const StyledSelect = withStyles({
  root: {
    background: 'transparent',
    // minWidth: '100px',
    // paddingLeft: '16px',
    display: 'flex',
    alignItems: 'center',
    color: '#545b7d',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px',
    paddingBottom: '6px',
    '&:focus': {
      background: 'transparent',
    },
  },
})(Select);

const SelectStyled = ({
  isDynamicTimeSlot,
  onChange,
  menus,
  name,
  id,
  value,
  label,
  customStyle,
  isAppointmentTime,
  usedIn,
  borderBottom,
  error,
  helperText,
  isAddNewPart,
  disabled,
}) => {
  const StyledMenuItem = withStyles(() => ({
    root: {
      '&:not(:last-child)': {
        borderBottom: '1px solid #eeeeee',
      },
      padding: '10px 20px',
      color: 'rgba(109, 125, 139, 1)',
      size: '14px',
    },
  }))(MenuItem);

  const useStyles = makeStyles({
    select__label: {
      fontSize: isAddNewPart ? '13px' : '13px',
      color: error ? '#E53935' : '#545B7D',
      lineHeight: '16px',
      fontWeight: 'normal',
      paddingBottom: isAddNewPart && '.5rem',
    },
    select__item: {
      width: '100%',
      borderBottom: '0.5px solid #545B7D',
    },
    select__adornment: {
      // marginRight: '1rem',
      '& .MuiButtonBase-root': {
        position: 'absolute',
        padding: 0,
        right: '32px',
        top: 'calc(50% - 12px)',
      },
    },
    styles__select: {
      // paddingLeft: '1rem',
      // paddingRight: '1rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '0.58rem',
      '& .MuiSelect-root': {
        paddingTop: '3px',
      },
    },
    styled__menu__item: {
      padding: '.5rem .7rem',
      '&:hover': {
        backgroundColor: 'rgba(105, 33, 196, 0.2)',
      },
      '&.Mui-selected': {
        backgroundColor: 'rgba(105, 33, 196, 0.2)',
        '&:hover': {
          background: 'rgba(105, 33, 196, 0.3)',
        },
      },
    },
    appointment__lr: {
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
    main__label: {
      color: '#545b7d',
      fontSize: '11px',
      fontWeight: 'normal',
      lineHeight: '17px',
    },
  });
  const classes = useStyles();
  const [expand] = React.useState(false);
  return (
    <>
      {label && (
        <label
          htmlFor={label}
          className={clsx(
            classes.select__label,
            usedIn === 'editVehicle' && classes.main__label,
          )}
        >
          {label}
        </label>
      )}

      <StyledSelect
        disabled={disabled}
        error={error}
        helperText={helperText}
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        disableUnderline={usedIn === 'vehicle' || borderBottom ? false : true}
        className={clsx(
          customStyle,
          classes.styles__select,
          'add__new__parts__text__field',
          isAppointmentTime && classes.appointment__lr,
        )}
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
          PaperProps: {
            style: {
              borderRadius: '15px',
              padding: '0 10px',
              marginTop: '10px',
              background: '#fff',
              left: '128px',
              maxHeight: '25vh',
            },
          },
        }}
        IconComponent={expand ? ExpandLessIcon : ExpandMoreIcon}
        // className={classes.select__styled}
        fullWidth
        startAdornment={
          isAppointmentTime && (
            <InputAdornment
              position='start'
              className={classes.select__adornment}
            >
              <TimePicker />
            </InputAdornment>
          )
        }
        renderValue={
          isDynamicTimeSlot
            ? (selected) => {
                const selectedItem = menus.find(
                  (menu) => menu.value === selected,
                );
                return selectedItem ? selectedItem.label : selected;
              }
            : undefined
        }
      >
        {menus.map((menu) => {
          return (
            <StyledMenuItem
              key={menu.value}
              value={isDynamicTimeSlot ? menu.label : menu.value}
              className={classes.styled__menu__item}
            >
              {/* {menu.highlight ? (
            <span key={String(index)} style={{ fontWeight: 500, color:'red' }}>
              {menu.label}
            </span>
          ) : (
            <strong key={String(index)} style={{ fontWeight: 300 }}>
              {menu.label}
            </strong>
          )} */}

              {menu.label || menu?.name}
            </StyledMenuItem>
          );
        })}
      </StyledSelect>
    </>
  );
};

export default SelectStyled;
